import api from 'api'
import { CACHE_TAG_INVOICE_VERSION_LIST, CACHE_TAG_ACCOUNT_INVOICE_LIST, CACHE_TAG_INVOICE_LIST } from 'api/cacheTagTypes'
import { WORK_ORDER_CACHE_INVALIDATION_TAGS, withDelayedWorkOrderInvalidation } from 'api/cacheInvalidationTagSets'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    regenerateAndRepostInvoice: build.mutation({
      query: body => ({ url: '/api/v1/billing/invoice/regenerate-and-repost', method: 'POST', body }),
      invalidatesTags: [
        CACHE_TAG_INVOICE_VERSION_LIST,
        CACHE_TAG_ACCOUNT_INVOICE_LIST,
        CACHE_TAG_INVOICE_LIST,
        ...WORK_ORDER_CACHE_INVALIDATION_TAGS,
      ],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
  }),
})

export const { useRegenerateAndRepostInvoiceMutation } = extendedApi
